import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {Row, Col} from "reactstrap";

import {
  FormField,
  CustomFormInput,
  SelectFormField
} from "../../../../utils/FormFields";
import Autosuggest from "../../../AutosuggestCompliance";
import CircularProggress from "../../../CircularProgress/CircularProgress";

function LegalAddress({
  legalAddress,
  onChangeAddress,
  autosuggests,
  onChangeAutosuggest,
  disabled,
  errors,
  services
}) {
  const [addressStates, setAddressStates] = useState(undefined);
  const [country, setCountry] = useState({
    id: legalAddress.LegalAddressCountryId
  });

  const fetchCountrySuggestion = name =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({text: name}, response => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map(c => {
            suggestions.push({
              id: c.Id,
              name: c.Name
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });

  const fetchCitySuggestion = name =>
    new Promise((resolve, reject) => {
      services.fetchGetCityAutosuggest(
        {
          name: name,
          nameState: legalAddress.LegalAddressStateName,
          nameCountry: legalAddress.LegalAddressCountryName
        },
        response => {
          if (response && response.suggestions) {
            const suggestions = [];
            response.suggestions.map(c => {
              suggestions.push({
                id: c.Id,
                name: c.Name
              });
              return {};
            });
            resolve(suggestions);
          } else {
            reject();
          }
        }
      );
    });

  const fetchStateSuggestion = name =>
    new Promise((resolve, reject) => {
      services.fetchGetStateAutosuggest(
        {nameState: name, nameCountry: legalAddress.LegalAddressCountryName},
        response => {
          if (response && response.suggestions) {
            const suggestions = [];
            response.suggestions.map(c => {
              suggestions.push({
                id: c.Id,
                name: c.Name
              });
              return {};
            });
            resolve(suggestions);
          } else {
            reject();
          }
        }
      );
    });

  const handleChangeCity = (id, value) => {
    const legalCityId = legalAddress.LegalAddressCityId;
    if (id !== legalCityId || legalCityId == undefined) {
      onChangeAddress("LegalAddressCityId", id, value);
    }
  };

  const onChangeCity = value => {
    onChangeAddress("LegalAddressCityId", undefined, value);
  };

  const handleChangeState = (id, value) => {
    const legalStateId = legalAddress.LegalAddressStateId;
    if (id !== legalStateId || legalStateId == undefined) {
      onChangeAddress("LegalAddressStateId", id, value);
    }
  };

  const onChangeState = value => {
    onChangeAddress("LegalAddressStateId", undefined, value);
  };

  const handleChangeCountry = (id, value) => {
    const legalCountryId = legalAddress.LegalAddressCountryId;
    if (id !== legalCountryId || legalCountryId == undefined) {
      onChangeAddress("LegalAddressCountryId", id, value);
    }
  };

  const onChangeCountry = value => {
    onChangeAddress("LegalAddressCountryId", undefined, value);
  };

  return (
    <div>
      <Row>
        <Col>
          <CustomFormInput
            label="Legal Address Country: "
            error={errors.LegalAddressCountryName}
          >
            <Autosuggest
              value={legalAddress.LegalAddressCountryName}
              onChange={onChangeCountry}
              fecthSuggestions={fetchCountrySuggestion}
              onSelect={handleChangeCountry}
              disabled={disabled}
            />
          </CustomFormInput>
        </Col>
        <Col>
          <CustomFormInput
            label="Legal Address State: "
            error={errors.LegalAddressStateName}
          >
            <Autosuggest
              value={legalAddress.LegalAddressStateName}
              onChange={onChangeState}
              fecthSuggestions={fetchStateSuggestion}
              onSelect={handleChangeState}
              disabled={legalAddress.LegalAddressCountryName == "" || disabled}
            />
          </CustomFormInput>
        </Col>
        <Col>
          <CustomFormInput
            label="Legal Address City: "
            error={errors.LegalAddressCityName}
          >
            <Autosuggest
              value={legalAddress.LegalAddressCityName}
              onChange={onChangeCity}
              fecthSuggestions={fetchCitySuggestion}
              onSelect={handleChangeCity}
              disabled={
                legalAddress.LegalAddressStateName == "" ||
                legalAddress.LegalAddressCountryName == "" ||
                disabled
              }
            />
          </CustomFormInput>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormField
            label="Legal Address Street: "
            value={legalAddress.LegalAddressStreet}
            name="LegalAddressStreet"
            onChange={onChangeAddress}
            disabled={disabled}
            error={errors.LegalAddressStreet}
          />
        </Col>
        <Col>
          <FormField
            label="Legal Address Number: "
            value={legalAddress.LegalAddressNumber}
            name="LegalAddressNumber"
            onChange={onChangeAddress}
            disabled={disabled}
            error={errors.LegalAddressNumber}
          />
        </Col>
        <Col>
          <FormField
            label="Legal Address Zip Code: "
            value={legalAddress.LegalAddressZipCode}
            name="LegalAddressZipCode"
            type="number"
            onChange={onChangeAddress}
            disabled={disabled}
            error={errors.LegalAddressZipCode}
            decimalScale={0}
          />
        </Col>
      </Row>
      <FormField
        label="Legal Address Neighbourhood: "
        value={legalAddress.LegalAddressExtraInformation1}
        name="LegalAddressExtraInformation1"
        type="textarea"
        onChange={onChangeAddress}
        disabled={disabled}
        error={errors.LegalAddressExtraInformation1}
      />
      <FormField
        label="Legal Address References: "
        value={legalAddress.LegalAddressExtraInformation2}
        name="LegalAddressExtraInformation2"
        type="textarea"
        onChange={onChangeAddress}
        disabled={disabled}
        error={errors.LegalAddressExtraInformation2}
      />
    </div>
  );
}

LegalAddress.propTypes = {
  legalAddress: PropTypes.object.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  autosuggests: PropTypes.object.isRequired,
  onChangeAutosuggest: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired
};

export default LegalAddress;
